import classes from './ProfileImage.module.scss';

const ProfileImage = ({ className, src, name, lastName }) => {
  const containerClasses = [classes.container];
  if (className) {
    containerClasses.push(className);
  }

  if (src) {
    return <img className={`${containerClasses.join(' ')} ${classes.img} `} src={src} alt='profile' />;
  }

  let letters = '';
  if (name) {
    letters += name.charAt(0).toUpperCase();
  }
  if (lastName) {
    letters += lastName.charAt(0).toUpperCase();
  }

  return <div className={`${containerClasses.join(' ')} ${classes.text} semibold-12`}>{letters}</div>;
};

export default ProfileImage;
